var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wout-login"},[_c('div',{staticClass:"center"},[_c('div',[_c('img',{attrs:{"src":require("@/assets/img/boaviagem.svg"),"width":"auto","height":"130","alt":"Boa Viagem!","crossorigin":""}})]),_c('span',{staticClass:"boaviagem"},[_vm._v("Tenha uma ótima viagem e até breve!")])])])
}]

export { render, staticRenderFns }